module.exports = __webpack_public_path__ + "assets/f1e9db591c24b4ab7c35db8e397f92b3.png";